module.exports = __webpack_public_path__ + "img/AnwarAbbasDPS-new.8a3c7f02.jpg";